var o = Object.prototype, i = o.hasOwnProperty;
function p(t) {
  var n = t.length, e = new t.constructor(n);
  return n && typeof t[0] == "string" && i.call(t, "index") && (e.index = t.index, e.input = t.input), e;
}
export {
  p as default
};
